import React from "react";
import { Form } from "sc/ui/components/Form";
import formWithMessages from "sc/ui/components/hoc/formWithMessages";

export const ERROR_EMPTY_NAME = "empty_name";
export const ERROR_EMPTY_TIMEZONE = "empty_timezone";
export const ERROR_EMPTY_SHIFT_DAYS = "empty_default_shift_days";

const shiftDays = [
  { name: "1", id: 1 },
  { name: "2", id: 2 },
  { name: "3", id: 3 },
  { name: "4", id: 4 },
  { name: "5", id: 5 },
  { name: "6", id: 6 },
  { name: "7", id: 7 },
];

export default formWithMessages(props => {
  const { region, onSave, disabled } = props;
  return (
    <Form
      formProps={{
        id: `region-form`,
        horizontal: true,
      }}
      onSubmit={onSave}
      {...props.messagesProps}
      fields={{
        name: {
          uiProps: {
            type: "text",
            placeholder: "Region name",
            autoFocus: true,
            maxLength: 100,
          },
          position: 1,
          initialValue: region.name,
          label: "Region Name ",
        },
        administrative: {
          uiProps: {
            type: "checkbox",
          },
          position: 2,
          initialValue: region.administrative,
          label: "Administrative Region ",
          hoverHelp: () =>
            "Setting a Region as ‘administrative’ signifies that this covers your entire service area. This can be used to define Regions or groups that aren’t geographically limited (e.g. your home office, NOC office, buried cable locators, etc.). Regions set as ‘administrative’ cannot have Cities assigned to them, and will appear in all search results.",
        },
        defaultShiftChangeTime: {
          uiProps: {
            type: "time",
            minuteStep: 15,
            showSecond: false,
            format: "hh:mm A",
            use12Hours: true,
            inputReadOnly: true,
            allowEmpty: false,
          },
          position: 3,
          initialValue: region.defaultShiftChangeTime,
          label: "Default Shift Change Time ",
          hoverHelp: () =>
            "Set the default time of day for the on-call shift change for this Region.",
        },
        defaultShiftDays: {
          uiProps: {
            type: "select",
            options: shiftDays,
          },
          position: 4,
          initialValue: region.defaultShiftDays,
          label: "Default shift duration in days",
          hoverHelp: () => "The default duration for a shift on this region",
        },
        enabled: {
          uiProps: {
            type: "checkbox",
          },
          position: 5,
          initialValue: region.enabled,
          label: "Enabled ",
          hoverHelp: () =>
            "Uncheck this box to disable this Region. This will hide the Region throughout your OCS system, and unassign any Engineers and Cities associated to this Region. You may re-enable the Region later but will need to reassign any Cities and Engineers to it.",
        },
        timeZone: {
          uiProps: {
            type: "timeZone",
          },
          position: 4,
          initialValue: region.timeZone,
          label: "Timezone",
          hoverHelp: () => "Set the timezone for this Region.",
        },
      }}
      validation={formData => {
        if (!formData.name) return ERROR_EMPTY_NAME;
        if (!formData.timeZone) return ERROR_EMPTY_TIMEZONE;
        if (formData.defaultShiftDays === "-1") return ERROR_EMPTY_SHIFT_DAYS;
        return undefined;
      }}
      submitButtonProps={{
        disabled,
        children: "Save",
        bsStyle: "primary",
      }}
      errorMessages={{
        [ERROR_EMPTY_NAME]: "Region name can't be empty",
        [ERROR_EMPTY_TIMEZONE]: "Please select a timezone",
        [ERROR_EMPTY_SHIFT_DAYS]: "Please select the default shift duration",
      }}
    />
  );
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/forms/Region.js